import { axiosInstance } from '../../../shared/api';

export async function verifyEmailWithToken(token) {
	try {
		const response = await axiosInstance.post(
			`auth/verify-email`,
			{ token },
			{
				withCredentials: true,
			},
		);
		if (response.status === 200) {
			return { success: true, data: response.data };
		}
	} catch (error) {
		if (error.response) {
			return {
				success: false,
				error:
					error.response.data?.detail ||
					error.response.data?.message ||
					'Verification failed',
			};
		}
		return { success: false, error: 'Network error. Please try again.' };
	}
}
